import { useContext } from 'react';
import { EditProposalContext } from 'contexts/EditProposaContext';
import { MainContext } from 'contexts/MainContext';

const useRemovedItem = (proposalId: string) => {
  const { editMode } = useContext(EditProposalContext);
  const { proposal } = useContext(MainContext);
  const proposalIndex =
    proposal.existingProposal?.listOfProducts?.findIndex((p) => p.id === proposalId) || 0;
  const currentProposal = proposal.existingProposal?.listOfProducts?.[proposalIndex];

  return currentProposal?.removed && editMode;
};

export default useRemovedItem;
